// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router";
import Header from './pages/Common/NavBar';
import Footer from './pages/Common/Footer';
import Home from './pages/Home/Home';
import ServiceCategory from './pages/ServiceCategory/Services';
import About from './pages/About/About';
import DrAesha from './pages/DrAesha/DrAesha';
import './App.css';
import './output.css';
import BeforeAndAfter from './pages/BeforeAfter/BeforeAndAfter';
import Technology from './pages/Technology/Technology';
import Blog from './pages/Blog/Blog';
import FAQ from './pages/FAQ/FAQ';
import ServiceDetails from './pages/ServiceDetail/ServiceDetails';
import AppointmentScheduler from './pages/Contact/AppointmentScheduler';
import ScrollToTop from './pages/Common/ScrollToTop';
import Warranty from './pages/Warranty/Warranty';
import NotFoundPage from './pages/NotFoundPage';
import ServiceFee from './pages/ServiceFee/ServiceFee';
import Service from './pages/Service/Service';
import ErrorBoundary from './pages/Common/ErrorBoundary';
import PristineSmileChatBot from './pages/Common/PristineSmileChatBot';

function App() {
  const serviceList = [
    'cleaning_exams', 'emergency_care', 'crowns', 'gum_therapy', 'dental_filling', 'denture',
    'night_guard', 'family_dentistry', 'invisalign', 'teeth_whitening', 'bonding', 'veneers', 'smile_makeover',
    'implants', 'extractions', 'root_canal', 'bone_grafts', 'implant_supported_dentures', 'bridges',
    'chipped_cracked_teeth', 'wisdom_tooth_pain', 'missing_tooth', 'toothcare', 'teeth_grinding',
    'stained_teeth', 'crooked_teeth', 'bleeding_gums', 'bad_breath'
  ]

  return (
    <Router>
        <div className="App">
          <ScrollToTop />
          <Header />
          <ErrorBoundary>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route path="/service" element={<Service />} />
              {/* <Route path="/new-patients" element={<NewPatients />} /> */}
              <Route path="/about" element={<About />} />
              <Route path="/dr-aesha" element={<DrAesha />} />
              <Route path="/before-after" element={<BeforeAndAfter />} />
              <Route path="/technology" element={<Technology />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/cleaning" element={<ServiceDetails />} />
              {/* <Route path="/filling" element={<ServiceDetails />} />
            <Route path="/root-canal" element={<ServiceDetails />} />
            <Route path="/veneer" element={<ServiceDetails />} />
            <Route path="/whitening" element={<ServiceDetails />} />
            <Route path="/bonding" element={<ServiceDetails />} />
            <Route path="/implant" element={<ServiceDetails />} />
            <Route path="/extraction" element={<ServiceDetails />} />
            <Route path="/wisdom-teeth" element={<ServiceDetails />} /> */}
              {
                serviceList.map((service) => (
                  <Route key={service} path={service} element={<ServiceDetails />} />
                ))
              }
              <Route path="/schedule-appointment" element={<AppointmentScheduler />} />
              <Route path="/warranty" element={<Warranty />} />
              <Route path="/general" element={<ServiceCategory />} />
              <Route path="/cosmetic" element={<ServiceCategory />} />
              <Route path="/surgical" element={<ServiceCategory />} />
              <Route path="/other" element={<ServiceCategory />} />
              <Route path="/service-fee" element={<ServiceFee />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </ErrorBoundary>
          <Footer />
          {/* Scroll to Top Button */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="fixed bottom-24 right-6 p-4 rounded-full shadow-lg transition-colors duration-300 opacity-90 hover:opacity-100 z-50 bg-gradient-to-r from-teal-600 to-lime-500 text-white"
            aria-label="Scroll to top"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
            </svg>
          </button>

          {/* Chatbot - stays at bottom-6 right-6 */}
          <PristineSmileChatBot />
        </div>
    </Router>
  );
}

export default App;